<template>
  <div class="c-filter">
    <ul
      v-if="showFilters"
      class="filter-by"
    >
      <li
        v-for="(item, index) in filters"
        :key="index"
      >
        <button
          :class="{
            'btn btn-danger btn-block-xs btn-block-sm': item.active,
            'btn btn-block-xs btn-block-sm background-white border-danger text-danger': !item.active
          }"
          @click="selectFilter(item.name)"
        >
          {{ item.text }}
        </button>
      </li>
    </ul>
    <div class="btn-wrapper">
      <Datepicker
        v-model="datepickerPeriod"
        format="{
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }"
        lang="ru"
        placeholder="Выбрать период"
        range
        @change="selectPeriod"
      />
      <Dropdown
        ref="dropdown"
        class="dropdown-custom"
      >
        <Btn
          class="dropdown-toggle"
          type="default"
        >
          Выбрать период
          <span class="caret" />
        </Btn>
        <template #dropdown>
          <li
            v-for="(item, index) in periods"
            :key="index"
            :class="{'hidden': item.name === 'user', 'active': item.active === true}"
          >
            <a
              role="button"
              @click="selectPeriodByName(item.name)"
            >
              {{ item.text }}
            </a>
          </li>
        </template>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import 'vue-datepicker-ui/lib/vuedatepickerui.css'
import '../../../../../../../resources/css/vuedatepickerui.css'
import Datepicker from 'vue-datepicker-ui'
import filters from '../../mixins/filters'
import periods from '../../mixins/periods'
import { Btn, Dropdown } from 'uiv'
import { capitalizeFirstLetter } from '../../../../../../../resources/js/helper'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CFilter',
  components: {
    Btn,
    Datepicker,
    Dropdown
  },
  mixins: [
    filters,
    periods
  ],
  props: {
    showFilters: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      datepickerPeriod: [],
      filters: {},
      filterName: 'device',
      periods: {},
      periodName: 'this_month'
    }
  },
  computed: {
    ...mapGetters({
      getFilterName: 'Filter/getFilterName',
      getPeriodName: 'Period/getPeriodName',
      getPeriod: 'Period/getPeriod'
    })
  },
  mounted () {
    this.filters = this.getFilters()
    this.periods = this.getPeriods()
    // Получаем значение из store, если есть
    const filterName = this.getFilterName
    if (filterName) {
      this.filterName = filterName
    }
    this.selectFilter(this.filterName)
    // Получаем значение из store, если есть
    const periodName = this.getPeriodName
    if (periodName) {
      this.periodName = periodName
    }
    const period = periodName !== 'user'
      ? this.getPeriodByName(this.periodName)
      : this.getPeriod
    this.updatePeriod(period)
    if (periodName !== 'user') {
      this.updatePeriodName(this.periodName)
    }
  },
  methods: {
    ...mapMutations({
      setFilterName: 'Filter/setFilterName',
      setPeriod: 'Period/setPeriod',
      setPeriodName: 'Period/setPeriodName'
    }),
    /**
     * Возвращает список доступных вариантов фильтра
     * @returns {{}}
     */
    getFilters () {
      const filters = {}
      const filterNames = [
        'device',
        'ad_network_type',
        'campaign_name',
        'date',
        'criterion'
      ]
      filterNames.forEach(item => {
        filters[item] = {
          text: capitalizeFirstLetter(this.getFilterText(item)),
          name: item,
          active: false
        }
      })
      return filters
    },
    /**
     * Возвращает список доступных вариантов периодов
     * @returns {{}}
     */
    getPeriods () {
      const periods = {}
      const periodNames = [
        'today',
        'yesterday',
        'this_week',
        'previous_week',
        'last_7_days',
        'this_month',
        'previous_month',
        'last_30_days',
        'last_90_days',
        'user'
      ]
      periodNames.forEach(item => {
        periods[item] = {
          text: this.getPeriodText(item),
          name: item,
          active: false
        }
      })
      return periods
    },
    /**
     * Устанавливает новое значение фильтра и сохраняет его состояние
     * @param filterName Название фильтра
     */
    selectFilter (filterName) {
      // Деактивируем предыдущий выбранный фильтр
      this.filters[this.filterName].active = false
      // Назначаем новый фильтр
      this.filterName = filterName
      // Активируем новый фильтр
      this.filters[this.filterName].active = true
      // Пишем в store
      this.setFilterName(filterName)
    },
    /**
     * Сохраняет новое значение периода из Datepicker в состояние
     * @param period
     */
    selectPeriod (period) {
      const localePeriod = {
        from: period[0].toLocaleDateString('en-CA'), // YYYY-mm-dd
        to: period[1].toLocaleDateString('en-CA') // YYYY-mm-dd
      }
      // Пишем в store
      this.setPeriod(localePeriod)
      const periodName = this.getNameByPeriod(localePeriod.from, localePeriod.to)
      this.updatePeriodName(periodName)
    },
    /**
     * Метод-обёртка, устанавливающий период и его название, и сохраняет их состояния
     * @param periodName
     */
    selectPeriodByName (periodName) {
      this.updatePeriodName(periodName)
      const period = this.getPeriodByName(periodName)
      this.updatePeriod(period)
    },
    /**
     * Устанавливает новый период и сохраняет его в состояние
     * @param period Период
     */
    updatePeriod (period) {
      this.datepickerPeriod = [
        new Date(period.from),
        new Date(period.to)
      ]
      // Пишем в store
      this.setPeriod(period)
    },
    /**
     * Устанавливает новое название периода и сохраняет его в состояние
     * @param periodName Название периода
     */
    updatePeriodName (periodName) {
      this.periods[this.periodName].active = false
      this.periodName = periodName
      this.periods[this.periodName].active = true
      // Пишем в store
      this.setPeriodName(periodName)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../../../resources/css/variables';

.c-filter {
  .filter-by {
    margin: 0;
    padding: 0;
    list-style: none;
    & > li {
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 0;
      @media all and (max-width: $xsBreakpoint - 1) {
        & {
          margin-bottom: 5px;
          width: 100%;
        }
      }
      @media all and (max-width: $smBreakpoint - 1) {
        & {
          margin-bottom: 5px;
          width: 45%;
          & > button {
            width: 100%;
          }
        }
      }
      &:last-child {
        margin: 0;
      }
    }
    & + .btn-wrapper {
      padding-top: 40px;
    }
  }
  .btn-wrapper {
    .v-calendar + .dropdown-custom {
      margin-left: 14px;
      @media all and (max-width: $xsBreakpoint - 1) {
        & {
          margin-left: 0;
          margin-top: 10px;
        }
      }
    }
  }
  .dropdown-custom {
    .dropdown-toggle {
      .caret {
        margin-left: 5px;
      }
    }
    li {
      margin-bottom: 0;
      &.divider {
        margin-bottom: 9px;
      }
      a {
        text-decoration: none;
      }
    }
  }
}
</style>
